import template from './on_hold.html'
import controller from './on_hold.controller'
import './on_hold.scss'

const OnHoldComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default OnHoldComponent;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/on_hold/on_hold.component.js